<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item label="标题">
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
      <el-form-item label="项目分类">
        <el-select v-model="searchForm.type" placeholder="项目分类" clearable>
          <el-option v-for="item in goodsTabTypeOptions" :label="item.title" :key="item.title" :value="item.id" />
        </el-select>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button type="primary" icon="CirclePlus" @click="editItem('add', {})" v-permission>添加</el-button>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" width="200" />
      <el-table-column prop="type" label="产品类型" width="200">
        <template #default="scope">
          {{ getTitleById(goodsTabTypeOptions, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="200" />
      <el-table-column prop="img" label="图片" width="200">
        <template #default="scope">
          {{ scope.row.img ? '' : '--' }}
          <el-image
            v-if="scope.row.img"
            class="previewImg"
            :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.img"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]"
            show-progress
            :initial-index="0"
            fit="cover"
          />
        </template>
      </el-table-column>

      <el-table-column label="操作" v-if="currentUser.role == 0" width="200" fixed="right">
        <template #default="scope">
          <el-button type="primary" icon="Edit" v-permission @click="editItem('edit', scope.row)">编辑</el-button>
          <el-button type="danger" icon="Delete" v-permission @click="deleteAction(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="新增/编辑" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
  import { ref, getCurrentInstance, onMounted } from 'vue'
  import { booleanEnums, getLabelByVal } from '@/config/enums'
  import EditPop from './components/goodsType/editPop.vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import { getTitleById, goodsTabTypeOptions } from '@/values/options'

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
  const searchForm = ref({
    title: '',
    type: 1,
  })
  const dialogFlag = ref(false)
  const editRow = ref({})
  const editFormRef = ref(null)
  const adminTableRef = ref(null)
  const formType = ref('add')
  const { proxy } = getCurrentInstance()

  onMounted(() => {
    getList()
  })

  const editItem = (type, row = {}) => {
    formType.value = type
    editRow.value = row
    dialogFlag.value = true
  }

  const submitForm = async () => {
    const url = formType.value == 'add' ? 'Goods/addGoodsClass' : 'Goods/updateGoodsClass'
    const data = editFormRef.value.form
    if (formType.value == 'add') {
      data.id = null
    }
    const res = await proxy.$http({
      method: 'post',
      url: url,
      data: {
        img: data.img,
        id: data.id,
        sort: data.sort,
        title: data.title,
        type: data.type,
      },
    })

    if (res.code == 0) {
      dialogFlag.value = false
      getList()
      ElMessage({
        type: 'success',
        message: res.msg,
      })
    } else {
      dialogFlag.value = false
      ElMessage({
        type: 'error',
        message: res.msg,
      })
    }
  }

  const deleteAction = (row) => {
    ElMessageBox.confirm('是否删除?', 'Warning', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        const res = await proxy.$http({
          method: 'get',
          url: 'Goods/deleteGoodsClass?id=' + row.id,
        })
        if (res.code == 0) {
          getList()
        }
        ElMessage({
          type: 'success',
          message: res.msg,
        })
      })
      .catch(() => {
        ElMessage({
          type: 'info',
          message: '取消删除',
        })
      })
  }

  const tableData = ref([])
  const page = ref(1)
  const limit = ref(10)
  const totalList = ref(0)
  const tableLoading = ref(false)

  const getList = async () => {
    tableLoading.value = true
    const res = await proxy.$http({
      type: 'get',
      url: '/Goods/getGoodsClassLists',
      params: Object.assign(
        {
          page: page.value,
          limit: limit.value,
        },
        searchForm.value
      ),
    })
    tableLoading.value = false
    if (res.code == 0) {
      tableData.value = res.data.data
      totalList.value = res.data.total
    }
  }
</script>

<style lang="less" scoped></style>
